
$(function () {
    $('input[name="Email"]').on('change', function () {
        if ($('input[name="EmailValidation_Verdict"]').length) {
            var $elem = $(this);
            var email = $elem.val();
            var isValid = $elem.valid();

            if (isValid) {

                $('input[name="EmailValidation_Verdict"]').val('');
                $('input[name="EmailValidation_Score_String"]').val('');
                $('input[name="EmailValidation_IsSuspectedDisposable"]').val('');

                $elem.nextAll('span.email-validation').remove();

                $.ajax({
                    url: '/email-validation',
                    type: 'POST',
                    data: { 'email': email },
                    success: function (result) {
                        if (result.success) {
                            $('input[name="EmailValidation_Verdict"]').val(result.verdict);
                            $('input[name="EmailValidation_Score_String"]').val(result.score);
                            $('input[name="EmailValidation_IsSuspectedDisposable"]').val(result.isSuspectedDisposable);

                            if (result.isRiskyOrInvalid) {
                                var languageString = result.hasSuggestion
                                    ? window.LANG_EmailValidation_RiskyOrInvalid_WithSuggestion.replace('{0}', result.suggestion)
                                    : window.LANG_EmailValidation_RiskyOrInvalid;

                                $elem.after('<span class="field-validation-error email-validation risky-or-invalid"><span class="is-invalid">' + languageString + '</span></span>');
                            } else {
                                if (result.hasSuggestion && window.LANG_EmailValidation_ValidWithSuggestion !== '') {
                                    var languageString = window.LANG_EmailValidation_ValidWithSuggestion.replace('{0}', result.suggestion);
                                    $elem.after('<span class="field-validation-error email-validation valid"><span class="is-valid">' + languageString + '</span></span>');
                                }
                            }
                        } else {
                            console.error(JSON.parse(result.response));
                        }
                    }
                });
            }
        }
    });

    $('input[name="EmailConfirm"]').bind('paste', function (e) {
        e.preventDefault();
        return false;
    });

    $('input[name="TelephoneConfirm"]').bind('paste', function (e) {
        e.preventDefault();
        return false;
    });
});